<template>
  <div class="employee-editor">
    <header class="topbar">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="backMainPanel" />
      <div class="topbar-title">
        <div class="kicker">Recursos Humanos</div>
        <h1>Perfil de empleado</h1>
        <p class="subtitle">{{ fullName }} · {{ localEmployeeDetails.employee_ident || "Sin ID" }}</p>
      </div>
      <div class="topbar-actions">
        <button class="btn ghost" type="button" @click="goBack">Cancelar</button>
        <button
          v-if="canDelete"
          class="btn danger"
          type="button"
          @click="confirmDelete"
          :disabled="saving_employee"
        >
          Eliminar empleado
        </button>
        <button
          v-if="canUpdate"
          class="btn primary"
          type="button"
          @click="saveEmployeeProfile"
          :disabled="saving_employee"
        >
          <span v-if="!saving_employee">Guardar</span>
          <span v-else>Guardando…</span>
        </button>
      </div>
    </header>

    <div class="tabs-wrap">
      <nav class="tabs">
        <button
          v-for="t in tabs"
          :key="t.key"
          class="tab"
          :class="{ active: activeTab === t.key }"
          @click="activeTab = t.key"
        >
          <span class="tab-label">{{ t.label }}</span>
          <span class="tab-hint" v-if="t.hint">{{ t.hint }}</span>
        </button>
      </nav>

      <div class="tab-panel">
        <section v-if="activeTab === 'employee'">
          <div class="main-data-container">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos de empleado</h4>
                  <div class="pill">Laboral</div>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">ID</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el ID" v-model="localEmployeeDetails.employee_ident" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Nombre(s)</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el nombre" v-model="localEmployeeDetails.employee_first_name" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Apellido paterno</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el primer apellido" v-model="localEmployeeDetails.employee_last_name" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Apellido materno</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el segundo apellido" v-model="localEmployeeDetails.employee_last_name2" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Posición</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la posición" v-model="localEmployeeDetails.employee_position" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de contratación</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la fecha de contratación" v-model="localEmployeeDetails.employee_hiring_date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Departamento</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.employee_department">
                          <option value="">Selecciona un departamento</option>
                          <option value="Remolque A, B">Remolque A, B</option>
                          <option value="Remolque C">Remolque C</option>
                          <option value="Remolque D">Remolque D</option>
                          <option value="Administración">Administración</option>
                          <option value="Ventas">Ventas</option>
                          <option value="Sistemas">Sistemas</option>
                          <option value="Operaciones">Operaciones</option>
                          <option value="Mantenimiento">Mantenimiento</option>
                          <option value="Almacén">Almacén</option>
                          <option value="Montacargas">Montacargas</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Grupo de Asistencia</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.attendance_group">
                          <option value="">Selecciona un grupo</option>
                          <option v-for="group in attendanceGroupOptions" :key="group" :value="group">{{ group }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Personal remoto</label>
                      <div class="field-control">
                        <div class="radio-group">
                          <label><input type="radio" v-model="localEmployeeDetails.is_remote" :value="true" /> Sí</label>
                          <label><input type="radio" v-model="localEmployeeDetails.is_remote" :value="false" /> No</label>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Ubicación</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.employee_location">
                          <option value="">Selecciona una ubicación</option>
                          <option value="Villa Mitras">Villa Mitras</option>
                          <option value="Lote Santa Catarina">Lote Santa Catarina</option>
                          <option value="Lote San Rafael">Lote San Rafael</option>
                          <option value="Lote San Roberto">Lote San Roberto</option>
                          <option value="Lote China">Lote China</option>
                          <option value="Saltillo">Saltillo</option>
                          <option value="Enzzo">Enzzo</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Empresa assignada</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.employee_assigned_company">
                          <option value="">Selecciona una empresa</option>
                          <option value="Grúas Monterrey, SA de CV">Grúas Monterrey, SA de CV</option>
                          <option value="Metro Grúas, SA de CV">Metro Grúas, SA de CV</option>
                          <option value="Gruás Saltillo, SA de CV">Gruás Saltillo, SA de CV</option>
                          <option value="Grúas Alfa, SA de CV">Grúas Alfa, SA de CV</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="maintenance-side">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Foto de perfil</h4>
                  <div class="pill">Avatar</div>
                </div>
                <div class="container-card-body">
                  <div class="profile-photo-wrap">
                    <img :src="profilePhotoUrl" class="profile-photo" alt="Perfil" />
                    <button type="button" class="btn primary" @click="uploadProfilePhoto" :disabled="uploadingMedia">
                      Subir imagen
                    </button>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Control de usuario del sistema</h4>
                  <div class="pill">Usuario del sistema</div>
                </div>
                <div class="container-card-body">
                  <div class="status-grid">
                    <div class="field">
                      <label class="field-label">Usuario asignado</label>
                      <div class="field-control">
                        <input type="text" :value="localEmployeeDetails.django_user_username || 'Sin usuario asignado'" disabled />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Estatus de usuario</label>
                      <div class="user-status-row">
                        <span class="user-status-chip" :class="{ active: djangoUserActive, inactive: !djangoUserActive }">
                          {{ djangoUserActive ? "Activo" : "Inactivo" }}
                        </span>
                        <button
                          v-if="canUpdate && localEmployeeDetails.django_user_username"
                          type="button"
                          class="btn ghost"
                          @click="toggleDjangoUserStatus"
                        >
                          {{ djangoUserActive ? "Desactivar usuario" : "Activar usuario" }}
                        </button>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Gestión de cuenta del sistema</label>
                      <div class="field-control">
                        <button
                          v-if="canUpdate"
                          type="button"
                          class="btn ghost"
                          :disabled="managingDjangoUser"
                          @click="openDjangoUserManager"
                        >
                          {{ managingDjangoUser ? "Procesando..." : "Asignar o crear usuario del sistema" }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Control de empleado RRHH</h4>
                  <div class="pill">Estatus interno</div>
                </div>
                <div class="container-card-body">
                  <div class="status-grid">
                    <div class="field">
                      <label class="field-label">Estatus interno de empleado</label>
                      <div class="user-status-row">
                        <span class="user-status-chip" :class="{ active: !employeeStatusIsInactive, inactive: employeeStatusIsInactive }">
                          {{ employeeStatusLabel }}
                        </span>
                        <button
                          v-if="canUpdate"
                          type="button"
                          class="btn ghost"
                          @click="toggleEmployeeStatus"
                        >
                          {{ employeeStatusIsInactive ? "Reactivar empleado" : "Marcar empleado inactivo" }}
                        </button>
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Fecha de baja</label>
                      <div class="field-control">
                        <input type="text" placeholder="Ej. 2026-03-12" v-model="localEmployeeDetails.employee_deactivation_date" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Motivo de baja</label>
                      <div class="field-control">
                        <input type="text" placeholder="Motivo principal" v-model="localEmployeeDetails.employee_deactivation_reason" />
                      </div>
                    </div>

                    <div class="field">
                      <label class="field-label">Comentarios de baja</label>
                      <div class="field-control">
                        <textarea placeholder="Detalles adicionales" v-model="localEmployeeDetails.employee_deactivation_notes"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'personal'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Dirección</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Calle y número</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la calle del personal" v-model="localEmployeeDetails.employee_street" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Colonia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la colonia" v-model="localEmployeeDetails.employee_neighborhood" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Municipio</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el municipio" v-model="localEmployeeDetails.employee_municipality" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Estado</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.employee_state">
                          <option value="">Selecciona un estado</option>
                          <option v-for="state in mexicoStates" :key="state" :value="state">{{ state }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Código postal</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el código postal" v-model="localEmployeeDetails.employee_postcode" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos personales</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Número de celular</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el número de celular" v-model="localEmployeeDetails.employee_phone" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Sexo</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.employee_sex">
                          <option value="1">Masculino</option>
                          <option value="2">Femenino</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de nacimiento</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la fecha de nacimiento" v-model="localEmployeeDetails.employee_birthdate" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Estado civil</label>
                      <div class="field-control">
                        <select v-model="localEmployeeDetails.employee_civil_state">
                          <option value="">Selecciona un estado civil</option>
                          <option value="Soltero">Soltero</option>
                          <option value="Casado">Casado</option>
                          <option value="Viudo">Viudo</option>
                          <option value="Union Libre">Union Libre</option>
                          <option value="Divorciado">Divorciado</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">RFC</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el RFC" v-model="localEmployeeDetails.employee_rfc" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">CURP</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el CURP" v-model="localEmployeeDetails.employee_curp" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Número del seguro social</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el SSN" v-model="localEmployeeDetails.employee_ssn" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Número de licencia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la licencia" v-model="localEmployeeDetails.employee_license_number" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Tipo de licencia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el tipo de licencia" v-model="localEmployeeDetails.employee_license_type" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Expiración de la licencia</label>
                      <div class="field-control">
                        <input type="date" v-model="localEmployeeDetails.employee_license_expiration" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos familiares</h4>
                  <button type="button" class="btn ghost mini-action-btn" @click="addFamilyMember">Agregar</button>
                </div>
                <div class="container-card-body">
                  <div v-for="(member, index) in familyMembersList" :key="`family-member-${index}`" class="list-row">
                    <div class="field">
                      <label class="field-label">Nombre</label>
                      <div class="field-control">
                        <input v-model.trim="member.name" type="text" placeholder="Nombre completo" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de nacimiento</label>
                      <div class="field-control">
                        <input v-model="member.birthdate" type="date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Parentezco</label>
                      <div class="field-control">
                        <input v-model.trim="member.relationship" type="text" placeholder="Ej. Cónyuge, hijo/a" />
                      </div>
                    </div>
                    <button type="button" class="btn remove-item-btn" @click="removeFamilyMember(index)">Quitar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'payroll'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Nómina / Sueldos</h4>
                  <button type="button" class="btn ghost mini-action-btn" @click="showPayrollHistory" :disabled="!employeeObjectId">
                    Ver historial
                  </button>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">% Comisiones</label>
                      <div class="field-control">
                        <input type="number" step="1" min="0" max="100" placeholder="0 a 100" v-model="localEmployeeDetails.employee_commission_percentage" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Sueldo pactado</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.agreed_salary" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Sueldo base IMSS</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.imss_base_salary" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Horas extras</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.extra_hours_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Horas extras triples</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.triple_extra_hours_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Turnos dobles</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.double_shifts_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Turnos triples</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.triple_shifts_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Premios semanales</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.weekly_incentive_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Complemento fijo</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.fixed_complement" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Pago de taxis</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="localEmployeeDetails.taxi_allowance" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Configuración</h4>
                </div>
                <div class="container-card-body">
                  <div class="payroll-config-grid">
                    <div class="payroll-config-column">
                      <h5>Datos Generales</h5>
                      <div class="field">
                        <label class="field-label">Pagar nómina</label>
                        <div class="field-control">
                          <div class="radio-group">
                            <label><input type="radio" v-model="localEmployeeDetails.pay_salary" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="localEmployeeDetails.pay_salary" :value="false" /> No</label>
                            <label><input type="radio" v-model="localEmployeeDetails.pay_salary" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Tipo de régimen</label>
                        <div class="field-control">
                          <select v-model="localEmployeeDetails.regime_type">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in regimeTypeOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Cotiza IMSS</label>
                        <div class="field-control">
                          <div class="radio-group">
                            <label><input type="radio" v-model="localEmployeeDetails.imss_afiliated" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="localEmployeeDetails.imss_afiliated" :value="false" /> No</label>
                            <label><input type="radio" v-model="localEmployeeDetails.imss_afiliated" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Forma de pago</label>
                        <div class="field-control">
                          <select v-model="localEmployeeDetails.payment_method">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in paymentMethodOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Frecuencia</label>
                        <div class="field-control">
                          <select v-model="localEmployeeDetails.payment_frequency">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in paymentFrequencyOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">UMF</label>
                        <div class="field-control">
                          <input type="text" v-model.trim="localEmployeeDetails.umf" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Omitir en Dispersión</label>
                        <div class="field-control">
                          <div class="radio-group">
                            <label><input type="radio" v-model="localEmployeeDetails.dispersion_omit" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="localEmployeeDetails.dispersion_omit" :value="false" /> No</label>
                            <label><input type="radio" v-model="localEmployeeDetails.dispersion_omit" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="payroll-config-column">
                      <h5>Bancos</h5>
                      <div class="bank-layout">
                        <div class="bank-row bank-row--account">
                          <label class="bank-label">Banco 1 y Cuenta</label>
                          <span class="bank-sep">:</span>
                          <select v-model="localEmployeeDetails.bank1" class="bank-select">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in bankOptions" :key="`bank1-${option}`" :value="option">{{ option }}</option>
                          </select>
                          <input type="text" class="bank-input" v-model.trim="localEmployeeDetails.bank1_account" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label">Clabe 1</label>
                          <span class="bank-sep">:</span>
                          <input type="text" class="bank-input bank-input--wide" v-model.trim="localEmployeeDetails.bank1_clabe" />
                        </div>
                        <div class="bank-row bank-row--account">
                          <label class="bank-label">Banco 2 y Cuenta</label>
                          <span class="bank-sep">:</span>
                          <select v-model="localEmployeeDetails.bank2" class="bank-select">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in bankOptions" :key="`bank2-${option}`" :value="option">{{ option }}</option>
                          </select>
                          <input type="text" class="bank-input" v-model.trim="localEmployeeDetails.bank2_account" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label">Clabe 2</label>
                          <span class="bank-sep">:</span>
                          <input type="text" class="bank-input bank-input--wide" v-model.trim="localEmployeeDetails.bank2_clabe" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label bank-label--multiline">Num. de Empleado para el Banco</label>
                          <span class="bank-sep">:</span>
                          <input type="number" step="1" min="0" class="bank-input bank-input--short" v-model.number="localEmployeeDetails.bank_employee_number" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label">Bonificar impuestos</label>
                          <span class="bank-sep">:</span>
                          <div class="bank-radio-group">
                            <label><input type="radio" v-model="localEmployeeDetails.tax_bonus" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="localEmployeeDetails.tax_bonus" :value="false" /> No</label>
                            <label><input type="radio" v-model="localEmployeeDetails.tax_bonus" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'files'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Documentos e imágenes</h4>
                  <button type="button" class="btn ghost media-download-all" @click="downloadAllEmployeeFiles">
                    DESCARGAR TODO
                  </button>
                </div>
                <div class="container-card-body">
                  <div class="media-section">
                    <div class="media-header">
                      <h5>Imágenes</h5>
                    </div>
                    <div class="media-grid">
                      <button type="button" class="media-card media-add" @click="uploadEmployeeFile('image')" :disabled="uploadingMedia">
                        <span class="media-plus">+</span>
                        <span class="media-add-label">Agregar imagen</span>
                      </button>

                      <div class="media-card" v-for="item in imageFiles" :key="item.file_id">
                        <img :src="item.preview_url" :alt="item.title || item.file_name" class="media-preview" />
                        <div class="media-meta">
                          <h6>{{ item.title || "Sin título" }}</h6>
                          <p>{{ item.description || "Sin descripción" }}</p>
                        </div>
                        <div class="media-actions">
                          <button type="button" class="btn ghost media-btn" @click="openFile(item)">Ver</button>
                          <button type="button" class="btn ghost media-btn" @click="downloadFile(item)">Descargar</button>
                          <button type="button" class="btn remove-item-btn media-btn" @click="deleteEmployeeFile(item.file_id)">Eliminar</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="media-section">
                    <div class="media-header">
                      <h5>Documentos</h5>
                    </div>
                    <div class="media-grid">
                      <button type="button" class="media-card media-add" @click="uploadEmployeeFile('document')" :disabled="uploadingMedia">
                        <span class="media-plus">+</span>
                        <span class="media-add-label">Agregar documento</span>
                      </button>

                      <div class="media-card" v-for="item in documentFiles" :key="item.file_id">
                        <div class="media-doc-icon">DOC</div>
                        <div class="media-meta">
                          <h6>{{ item.title || item.file_name || "Documento" }}</h6>
                          <p>{{ item.description || "Sin descripción" }}</p>
                        </div>
                        <div class="media-actions">
                          <button type="button" class="btn ghost media-btn" @click="openFile(item)">Abrir</button>
                          <button type="button" class="btn ghost media-btn" @click="downloadFile(item)">Descargar</button>
                          <button type="button" class="btn remove-item-btn media-btn" @click="deleteEmployeeFile(item.file_id)">Eliminar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'incidents'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Incidencias</h4>
                  <div class="incident-header-actions">
                    <div class="pill">Disciplina interna</div>
                    <button
                      v-if="!showIncidentForm"
                      type="button"
                      class="btn ghost mini-action-btn"
                      @click="showIncidentForm = true"
                      :disabled="!canCreateIncident"
                    >
                      Crear nueva incidencia
                    </button>
                  </div>
                </div>
                <div class="container-card-body incident-layout">
                  <div v-if="showIncidentForm" class="incident-card incident-card-new">
                    <div class="incident-card-header">
                      <h5>Nueva incidencia</h5>
                      <div class="incident-form-actions">
                        <button type="button" class="btn ghost mini-action-btn" @click="cancelIncidentCreation" :disabled="savingIncident">
                          Cancelar
                        </button>
                        <button
                          type="button"
                          class="btn primary mini-action-btn"
                          @click="createEmployeeIncident"
                          :disabled="savingIncident || !canCreateIncident"
                        >
                          {{ savingIncident ? "Guardando..." : "Guardar incidencia" }}
                        </button>
                      </div>
                    </div>
                    <div class="form-grid incident-grid">
                      <div class="field">
                        <label class="field-label">Fecha de creación</label>
                        <div class="field-control">
                          <input type="text" :value="incidentCreationPreview" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Fecha de ocurrencia</label>
                        <div class="field-control">
                          <input type="datetime-local" v-model="incidentDraft.occurrence_time" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Empleado</label>
                        <div class="field-control">
                          <input type="text" :value="fullName" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Categoria</label>
                        <div class="field-control">
                          <select v-model="incidentDraft.category">
                            <option value="">Todas</option>
                            <option v-for="category in incidentCategoryOptions" :key="`new-category-${category}`" :value="category">
                              {{ category }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Nivel</label>
                        <div class="field-control">
                          <input type="text" :value="incidentLevelLabel(incidentDraft.level)" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Tipo</label>
                        <div class="field-control">
                          <select v-model="incidentDraft.type">
                            <option value="">Selecciona un tipo</option>
                            <option v-for="option in newIncidentTypeOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Elabora</label>
                        <div class="field-control">
                          <input type="text" :value="currentUserDisplay || 'Autodetectado al guardar'" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Costo</label>
                        <div class="field-control">
                          <input type="number" step="0.01" inputmode="decimal" v-model="incidentDraft.cost" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Unidad</label>
                        <div class="field-control">
                          <select v-model="incidentDraft.unit">
                            <option :value="null">Sin unidad</option>
                            <option v-for="unit in incidentUnits" :key="unit.id" :value="unit.id">
                              {{ unit.unit_short_id }} - {{ unit.unit_sub_brand }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Fecha correctiva</label>
                        <div class="field-control">
                          <input type="date" v-model="incidentDraft.punishment_date" />
                        </div>
                      </div>
                      <div class="field field-full">
                        <label class="field-label">Descripción</label>
                        <div class="field-control">
                          <textarea v-model.trim="incidentDraft.description" placeholder="Describe la falta o comportamiento"></textarea>
                        </div>
                      </div>
                      <div class="field field-full">
                        <label class="field-label">Acción correctiva</label>
                        <div class="field-control">
                          <textarea v-model.trim="incidentDraft.punishment_description" placeholder="Describe la acción correctiva"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="!employeeIncidents.length" class="incident-empty">No hay incidencias registradas para este empleado.</div>
                  <div v-for="incident in employeeIncidents" :key="incident.id" class="incident-card">
                    <div class="incident-card-header">
                      <div class="incident-title-wrap">
                        <h5>Incidencia #{{ incident.id }}</h5>
                        <span class="incident-status-pill" :class="incidentStatusClass(incident.status)">
                          {{ incident.status || 'En revision' }}
                        </span>
                      </div>
                      <div class="incident-form-actions">
                        <template v-if="editingIncidentId === incident.id">
                          <button
                            type="button"
                            class="btn ghost mini-action-btn"
                            @click="cancelEditIncident"
                            :disabled="savingIncidentEdits"
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            class="btn primary mini-action-btn"
                            @click="saveIncidentEdits(incident)"
                            :disabled="savingIncidentEdits"
                          >
                            {{ savingIncidentEdits ? "Guardando..." : "Guardar cambios" }}
                          </button>
                        </template>
                        <template v-else>
                          <button
                            v-if="canEditIncident"
                            type="button"
                            class="btn ghost mini-action-btn"
                            @click="startEditIncident(incident)"
                            :disabled="savingIncident"
                          >
                            Editar
                          </button>
                          <button
                            v-if="canCloseIncident && !isIncidentClosed(incident)"
                            type="button"
                            class="btn primary mini-action-btn"
                            @click="closeEmployeeIncident(incident)"
                            :disabled="savingIncident"
                          >
                            Cerrar incidencia
                          </button>
                          <button
                            type="button"
                            class="btn remove-item-btn mini-action-btn"
                            @click="deleteEmployeeIncident(incident)"
                            :disabled="savingIncident || !canDeleteIncident"
                          >
                            Eliminar
                          </button>
                        </template>
                      </div>
                    </div>
                    <div class="form-grid incident-grid">
                      <div class="field">
                        <label class="field-label">Fecha de creación</label>
                        <div class="field-control">
                          <input type="text" :value="formatIncidentDateTime(incident.request_time)" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Fecha de ocurrencia</label>
                        <div class="field-control">
                          <input v-if="editingIncidentId === incident.id" type="datetime-local" v-model="editIncidentDraft.occurrence_time" />
                          <input v-else type="text" :value="formatIncidentDateTime(incident.occurrence_time)" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Empleado</label>
                        <div class="field-control">
                          <input type="text" :value="incident.employee_involved_name || fullName" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Categoria</label>
                        <div class="field-control">
                          <select v-if="editingIncidentId === incident.id" v-model="editIncidentDraft.category">
                            <option value="">Todas</option>
                            <option v-for="category in incidentCategoryOptions" :key="`edit-category-${category}`" :value="category">
                              {{ category }}
                            </option>
                          </select>
                          <input v-else type="text" :value="getCategoryForIncidentType(incident.type) || '-'" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Nivel</label>
                        <div class="field-control">
                          <input v-if="editingIncidentId === incident.id" type="text" :value="incidentLevelLabel(editIncidentDraft.level)" disabled />
                          <input v-else type="text" :value="incidentLevelLabel(incident.level)" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Tipo</label>
                        <div class="field-control">
                          <select v-if="editingIncidentId === incident.id" v-model="editIncidentDraft.type">
                            <option value="">Selecciona un tipo</option>
                            <option v-for="option in editIncidentTypeOptions" :key="`edit-type-${option}`" :value="option">{{ option }}</option>
                          </select>
                          <input v-else type="text" :value="incident.type || '-'" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Elabora</label>
                        <div class="field-control">
                          <input type="text" :value="incident.data_entry_clerk_name || '-'" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Costo</label>
                        <div class="field-control">
                          <input v-if="editingIncidentId === incident.id" type="number" step="0.01" inputmode="decimal" v-model="editIncidentDraft.cost" />
                          <input v-else type="text" :value="incident.cost ?? '-'" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Unidad</label>
                        <div class="field-control">
                          <select v-if="editingIncidentId === incident.id" v-model="editIncidentDraft.unit">
                            <option :value="null">Sin unidad</option>
                            <option v-for="unit in incidentUnits" :key="`edit-unit-${unit.id}`" :value="unit.id">
                              {{ unit.unit_short_id }} - {{ unit.unit_sub_brand }}
                            </option>
                          </select>
                          <input v-else type="text" :value="incident.unit_short_id ? `${incident.unit_short_id} - ${incident.unit_sub_brand || ''}` : 'Sin unidad'" disabled />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Fecha correctiva</label>
                        <div class="field-control">
                          <input v-if="editingIncidentId === incident.id" type="date" v-model="editIncidentDraft.punishment_date" />
                          <input v-else type="text" :value="incident.punishment_date || '-'" disabled />
                        </div>
                      </div>
                      <div class="field field-full">
                        <label class="field-label">Descripción</label>
                        <div class="field-control">
                          <textarea v-if="editingIncidentId === incident.id" v-model.trim="editIncidentDraft.description" placeholder="Describe la falta o comportamiento"></textarea>
                          <textarea v-else :value="incident.description || '-'" disabled></textarea>
                        </div>
                      </div>
                      <div class="field field-full">
                        <label class="field-label">Acción correctiva</label>
                        <div class="field-control">
                          <textarea v-if="editingIncidentId === incident.id" v-model.trim="editIncidentDraft.punishment_description" placeholder="Describe la acción correctiva"></textarea>
                          <textarea v-else :value="incident.punishment_description || '-'" disabled></textarea>
                        </div>
                      </div>
                      <div class="field field-full">
                        <label class="field-label">Firma de enterado</label>
                        <div class="field-control">
                          <div v-if="incident.acknowledgement_signature" class="incident-signature-view">
                            <img :src="incident.acknowledgement_signature" alt="Firma de enterado" />
                          </div>
                          <div v-else class="incident-signature-empty">Sin firma</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer class="savebar">
      <div class="savebar-left">
        <span class="savebar-text">{{ fullName }}</span>
      </div>
      <div class="savebar-actions">
        <button class="btn ghost" type="button" @click="goBack">Cancelar</button>
        <button v-if="canUpdate" class="btn primary" type="button" @click="saveEmployeeProfile" :disabled="saving_employee">
          <span v-if="!saving_employee">Guardar</span>
          <span v-else>Guardando…</span>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { EMPLOYEE_INCIDENT_CATALOG } from "@/constants/employeeIncidentCatalog";

export default {
  name: "EditEmployeeProfile",
  props: ["employeeDetails"],
  data() {
    return {
      activeTab: "employee",
      saving_employee: false,
      uploadingMedia: false,
      savingIncident: false,
      managingDjangoUser: false,
      permissions: [],
      localEmployeeDetails: { ...this.employeeDetails },
      persistedEmployeeDetails: { ...this.employeeDetails },
      familyMembersList: [],
      profilePhoto: null,
      imageFiles: [],
      documentFiles: [],
      employeeIncidents: [],
      incidentUnits: [],
      currentUserEmployeeId: null,
      currentUserDisplay: "",
      showIncidentForm: false,
      editingIncidentId: null,
      savingIncidentEdits: false,
      editIncidentDraft: {
        occurrence_time: "",
        category: "",
        level: "",
        type: "",
        cost: "",
        unit: null,
        punishment_date: "",
        description: "",
        punishment_description: "",
      },
      tabs: [
        { key: "employee", label: "Datos de Empleado", hint: "Laboral y perfil" },
        { key: "personal", label: "Datos Personales", hint: "Contacto y dirección" },
        { key: "payroll", label: "Nomina / Sueldos", hint: "Percepciones y valores" },
        { key: "files", label: "Documentos e Imágenes", hint: "Archivos adjuntos" },
        { key: "incidents", label: "Incidencias", hint: "Disciplina y correctivos" },
      ],
      mexicoStates: [
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Campeche",
        "Chiapas",
        "Chihuahua",
        "Ciudad de México",
        "Coahuila",
        "Colima",
        "Durango",
        "Estado de México",
        "Guanajuato",
        "Guerrero",
        "Hidalgo",
        "Jalisco",
        "Michoacán",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "San Luis Potosí",
        "Sinaloa",
        "Sonora",
        "Tabasco",
        "Tamaulipas",
        "Tlaxcala",
        "Veracruz",
        "Yucatán",
        "Zacatecas",
      ],
      regimeTypeOptions: [
        "Sueldos",
        "Jubilados",
        "Pensionados",
        "Asimilados Miembros Sociedades Cooperativas",
        "Asimilados Integrantes Sociedades Asocia",
        "Asimilados Miembros Consejos",
        "Asimilados Comisionistas",
        "Asimilados Honorarios",
        "Asimilados Acciones",
        "Asimilados Otros",
        "Jubilados o Pensionados",
        "Indemnizacion o Separacion",
        "Otro",
      ],
      paymentMethodOptions: ["Efectivo", "Cheque", "Transferencia", "Ninguno"],
      paymentFrequencyOptions: ["Semanal", "Asimilados", "Ninguno"],
      bankOptions: ["Banregio", "BBVA", "Banamex", "Banorte", "Ban Bajio", "Santander", "HSBC", "Otro"],
      attendanceGroupOptions: [
        "Saltillo",
        "Mantenimiento",
        "Auxilio Vial",
        "Enzzo",
        "Montacargas",
        "Call Center",
        "Radio",
        "Administración",
        "Remolque A/B",
        "Remolque C/D",
      ],
      employeeStatusOptions: [
        { value: 1, label: "Activo" },
        { value: 2, label: "Inactivo" },
      ],
      incidentLevelOptions: [
        { value: "1", label: "1 - Leve" },
        { value: "2", label: "2 - Moderada" },
        { value: "3", label: "3 - Grave" },
        { value: "4", label: "4 - Muy Grave" },
      ],
      incidentDraft: {
        occurrence_time: "",
        category: "",
        level: "",
        type: "",
        cost: "",
        description: "",
        unit: null,
        punishment_date: "",
        punishment_description: "",
      },
    };
  },
  computed: {
    canUpdate() {
      return this.permissions.includes("rrhh.update_employee");
    },
    canDelete() {
      return this.permissions.includes("rrhh.delete_employee");
    },
    canCreateIncident() {
      return (
        this.permissions.includes("access_control.ui_access_rrhh_incidents_create")
        || this.permissions.includes("ui_access_rrhh_incidents_create")
      );
    },
    canDeleteIncident() {
      return this.permissions.includes("rrhh.delete_employee_incident") || this.permissions.includes("rrhh.update_employee");
    },
    canCloseIncident() {
      return (
        this.permissions.includes("access_control.ui_access_rrhh_incidents_close")
        || this.permissions.includes("ui_access_rrhh_incidents_close")
      );
    },
    canEditIncident() {
      return (
        this.permissions.includes("access_control.ui_access_rrhh_incidents_create")
        || this.permissions.includes("ui_access_rrhh_incidents_create")
      );
    },
    fullName() {
      return [
        this.localEmployeeDetails.employee_last_name,
        this.localEmployeeDetails.employee_last_name2,
        this.localEmployeeDetails.employee_first_name,
      ].filter(Boolean).join(" ") || "Empleado";
    },
    employeeObjectId() {
      return this.employeeDetails?.employee_ident;
    },
    djangoUserActive() {
      if (typeof this.localEmployeeDetails.django_user_is_active === "boolean") {
        return this.localEmployeeDetails.django_user_is_active;
      }
      return !!this.localEmployeeDetails.django_user_is_active_display;
    },
    employeeStatusId() {
      return this.normalizeStatusId(this.localEmployeeDetails.employee_status);
    },
    employeeStatusIsInactive() {
      return this.isInactiveStatusValue(this.localEmployeeDetails.employee_status);
    },
    employeeStatusLabel() {
      const option = this.employeeStatusOptions.find((item) => item.value === this.employeeStatusId);
      if (option) return option.label;
      if (this.employeeStatusId) return `Estatus #${this.employeeStatusId}`;
      return "Sin estatus";
    },
    profilePhotoUrl() {
      return this.profilePhoto?.preview_url || require("@/assets/client-icon.png");
    },
    incidentCreationPreview() {
      return new Date().toLocaleString("es-MX");
    },
    incidentCategoryOptions() {
      return [...new Set(EMPLOYEE_INCIDENT_CATALOG.map((row) => row.category))];
    },
    newIncidentTypeOptions() {
      return this.filterIncidentTypesByCategory(this.incidentDraft.category);
    },
    editIncidentTypeOptions() {
      return this.filterIncidentTypesByCategory(this.editIncidentDraft.category);
    },
  },
  watch: {
    employeeDetails: {
      deep: true,
      handler(newVal) {
        this.localEmployeeDetails = { ...newVal };
        this.persistedEmployeeDetails = { ...newVal };
        this.ensureNormalizedEmployeeStatus();
        this.hydrateFamilyMembers(newVal);
        this.fetchEmployeeFiles();
        this.fetchEmployeeIncidents();
      },
    },
    "incidentDraft.category"(newCategory) {
      const allowedTypes = this.filterIncidentTypesByCategory(newCategory);
      if (this.incidentDraft.type && !allowedTypes.includes(this.incidentDraft.type)) {
        this.incidentDraft.type = "";
      }
    },
    "editIncidentDraft.category"(newCategory) {
      const allowedTypes = this.filterIncidentTypesByCategory(newCategory);
      if (this.editIncidentDraft.type && !allowedTypes.includes(this.editIncidentDraft.type)) {
        this.editIncidentDraft.type = "";
      }
    },
    "incidentDraft.type"(newType) {
      this.incidentDraft.level = this.getLevelForIncidentType(newType);
    },
    "editIncidentDraft.type"(newType) {
      this.editIncidentDraft.level = this.getLevelForIncidentType(newType);
    },
  },
  async created() {
    this.localEmployeeDetails = { ...this.employeeDetails };
    this.persistedEmployeeDetails = { ...this.employeeDetails };
    this.ensureNormalizedEmployeeStatus();
    this.hydrateFamilyMembers(this.employeeDetails);
    this.loadPermissions();
    await this.fetchCurrentUser();
    await this.fetchIncidentUnits();
    await this.fetchEmployeeIncidents();
    await this.fetchEmployeeFiles();
  },
  methods: {
    resetIncidentDraft() {
      this.incidentDraft = {
        occurrence_time: "",
        category: "",
        level: "",
        type: "",
        cost: "",
        description: "",
        unit: null,
        punishment_date: "",
        punishment_description: "",
      };
    },
    cancelIncidentCreation() {
      this.resetIncidentDraft();
      this.showIncidentForm = false;
    },
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];
      } catch (error) {
        this.permissions = [];
      }
    },
    backMainPanel() {
      window.location.href = "/main-panel";
    },
    defaultFamilyMember() {
      return { name: "", birthdate: "", relationship: "" };
    },
    normalizeFamilyMembers(value) {
      if (Array.isArray(value) && value.length) {
        return value.map((item) => ({
          name: (item?.name || "").toString(),
          birthdate: (item?.birthdate || "").toString(),
          relationship: (item?.relationship || "").toString(),
        }));
      }
      return [this.defaultFamilyMember()];
    },
    sanitizeFamilyMembers() {
      const cleaned = this.familyMembersList
        .map((item) => ({
          name: (item?.name || "").trim(),
          birthdate: item?.birthdate || "",
          relationship: (item?.relationship || "").trim(),
        }))
        .filter((item) => item.name || item.birthdate || item.relationship);
      return cleaned.length ? cleaned : null;
    },
    normalizeDecimalValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return value;
    },
    normalizeCommissionValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return value;
    },
    normalizeTextValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return String(value).trim();
    },
    normalizeIntegerValue(value) {
      if (value === null || value === undefined || value === "") return null;
      const parsed = Number(value);
      if (Number.isNaN(parsed)) return null;
      return parsed;
    },
    normalizeStatusId(value) {
      if (value === null || value === undefined || value === "") return null;
      if (typeof value === "number") return value;
      if (typeof value === "string") {
        const parsed = Number(value);
        return Number.isNaN(parsed) ? null : parsed;
      }
      if (typeof value === "object" && value?.id !== undefined && value?.id !== null) {
        const parsed = Number(value.id);
        return Number.isNaN(parsed) ? null : parsed;
      }
      return null;
    },
    isInactiveStatusValue(value) {
      const statusId = this.normalizeStatusId(value);
      if (statusId === 2) return true;
      const statusText = String(value?.status || value || "").trim().toLowerCase();
      if (!statusText) return false;
      return ["inactivo", "inactive", "baja", "suspendido"].some((term) => statusText.includes(term));
    },
    ensureNormalizedEmployeeStatus() {
      const normalizedStatusId = this.normalizeStatusId(this.localEmployeeDetails.employee_status);
      if (normalizedStatusId !== null) {
        this.localEmployeeDetails.employee_status = normalizedStatusId;
      }
    },
    fillDeactivationDateWhenMissing() {
      if (this.localEmployeeDetails.employee_deactivation_date) return;
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      this.localEmployeeDetails.employee_deactivation_date = `${year}-${month}-${day}`;
    },
    resolveApiErrorMessage(error, fallbackMessage) {
      return error?.response?.data?.error || fallbackMessage;
    },
    syncDjangoUserFieldsFromResponse(serverEmployee) {
      if (!serverEmployee || typeof serverEmployee !== "object") return;
      const djangoFields = {
        employee_user: serverEmployee.employee_user ?? null,
        django_user_username: serverEmployee.django_user_username ?? null,
        django_user_is_active_display: !!serverEmployee.django_user_is_active_display,
        django_user_is_active: !!serverEmployee.django_user_is_active_display,
      };
      this.localEmployeeDetails = {
        ...this.localEmployeeDetails,
        ...djangoFields,
      };
      this.persistedEmployeeDetails = {
        ...this.persistedEmployeeDetails,
        ...djangoFields,
      };
    },
    async fetchDjangoUserCandidates() {
      const employee_ident = this.employeeDetails.employee_ident;
      const apiDirectory = process.env.API_DIRECTORY;
      const response = await axios.get(`${apiDirectory}/employee-django-users/${employee_ident}/`);
      return Array.isArray(response.data?.results) ? response.data.results : [];
    },
    async assignExistingDjangoUser() {
      const users = await this.fetchDjangoUserCandidates();
      if (!users.length) {
        Swal.fire("Sin usuarios", "No hay usuarios del sistema disponibles.", "info");
        return;
      }

      const optionsHtml = users
        .map((row) => {
          const fullName = [row.first_name, row.last_name].filter(Boolean).join(" ").trim();
          const statusLabel = row.is_active ? "Activo" : "Inactivo";
          const assignmentLabel = row.assigned_to_other_employee
            ? ` - Asignado a ${this.escapeHtml(row.assigned_employee_ident || "otro empleado")}`
            : "";
          const disabledAttr = row.assigned_to_other_employee ? "disabled" : "";
          const selectedAttr = this.localEmployeeDetails.employee_user === row.id ? "selected" : "";
          const label = `${this.escapeHtml(row.username)}${fullName ? ` (${this.escapeHtml(fullName)})` : ""} - ${statusLabel}${assignmentLabel}`;
          return `<option value="${row.id}" ${disabledAttr} ${selectedAttr}>${label}</option>`;
        })
        .join("");

      const pickResult = await Swal.fire({
        title: "Asignar usuario existente",
        html: `
          <select id="django-user-select" class="swal2-input" style="max-width:100%; width:100%;">
            <option value="">Selecciona un usuario</option>
            ${optionsHtml}
          </select>
        `,
        showCancelButton: true,
        confirmButtonText: "Asignar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const selected = document.getElementById("django-user-select")?.value;
          if (!selected) {
            Swal.showValidationMessage("Selecciona un usuario.");
            return null;
          }
          return selected;
        },
      });
      if (!pickResult.isConfirmed || !pickResult.value) return;

      const employee_ident = this.employeeDetails.employee_ident;
      const apiDirectory = process.env.API_DIRECTORY;
      const response = await axios.post(`${apiDirectory}/employee-assign-django-user/${employee_ident}/`, {
        user_id: Number(pickResult.value),
      });
      this.syncDjangoUserFieldsFromResponse(response.data);
      Swal.fire("Actualizado", "El usuario del sistema se asignó correctamente.", "success");
    },
    async createAndAssignDjangoUser() {
      const createResult = await Swal.fire({
        title: "Crear y asignar usuario del sistema",
        html: `
          <input id="new-django-username" class="swal2-input" placeholder="Username">
          <input id="new-django-password" class="swal2-input" type="password" placeholder="Password">
          <input id="new-django-first-name" class="swal2-input" placeholder="Nombre (opcional)">
          <input id="new-django-last-name" class="swal2-input" placeholder="Apellido (opcional)">
          <input id="new-django-email" class="swal2-input" placeholder="Correo (opcional)">
        `,
        showCancelButton: true,
        confirmButtonText: "Crear y asignar",
        cancelButtonText: "Cancelar",
        focusConfirm: false,
        preConfirm: () => {
          const username = document.getElementById("new-django-username")?.value?.trim() || "";
          const password = document.getElementById("new-django-password")?.value || "";
          const first_name = document.getElementById("new-django-first-name")?.value?.trim() || "";
          const last_name = document.getElementById("new-django-last-name")?.value?.trim() || "";
          const email = document.getElementById("new-django-email")?.value?.trim() || "";
          if (!username) {
            Swal.showValidationMessage("El username es obligatorio.");
            return null;
          }
          if (!password) {
            Swal.showValidationMessage("El password es obligatorio.");
            return null;
          }
          return { username, password, first_name, last_name, email };
        },
      });
      if (!createResult.isConfirmed || !createResult.value) return;

      const employee_ident = this.employeeDetails.employee_ident;
      const apiDirectory = process.env.API_DIRECTORY;
      const response = await axios.post(
        `${apiDirectory}/employee-create-django-user/${employee_ident}/`,
        createResult.value,
      );
      this.syncDjangoUserFieldsFromResponse(response.data);
      Swal.fire("Actualizado", "El nuevo usuario del sistema se creó y asignó correctamente.", "success");
    },
    async openDjangoUserManager() {
      try {
        if (!this.canUpdate) {
          Swal.fire("Sin acceso", "No tienes permisos para actualizar personal.", "warning");
          return;
        }
        this.managingDjangoUser = true;
        const actionResult = await Swal.fire({
          title: "Gestionar usuario del sistema",
          input: "radio",
          inputOptions: {
            existing: "Asignar usuario existente",
            create: "Crear y asignar nuevo usuario",
          },
          inputValidator: (value) => (!value ? "Selecciona una opción." : null),
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        });
        if (!actionResult.isConfirmed || !actionResult.value) return;
        if (actionResult.value === "existing") {
          await this.assignExistingDjangoUser();
          return;
        }
        await this.createAndAssignDjangoUser();
      } catch (error) {
        const errorCode = error?.response?.data?.error_code;
        if (errorCode === "duplicate_username") {
          Swal.fire("Username duplicado", "Ese username ya existe en el sistema. Elige otro.", "error");
          return;
        }
        if (errorCode === "username_assigned_to_employee") {
          const employeeIdent = error?.response?.data?.employee_ident;
          const details = employeeIdent ? ` Ya está vinculado al empleado ${employeeIdent}.` : "";
          Swal.fire("Username ya asignado", `Ese username ya está ligado a otro empleado.${details}`, "error");
          return;
        }
        Swal.fire("Error", this.resolveApiErrorMessage(error, "No se pudo gestionar el usuario del sistema."), "error");
      } finally {
        this.managingDjangoUser = false;
      }
    },
    buildEmployeePayload(sourcePayload) {
      const payload = { ...sourcePayload };
      payload.employee_commission_percentage = this.normalizeCommissionValue(payload.employee_commission_percentage);
      payload.agreed_salary = this.normalizeDecimalValue(payload.agreed_salary);
      payload.imss_base_salary = this.normalizeDecimalValue(payload.imss_base_salary);
      payload.extra_hours_value = this.normalizeDecimalValue(payload.extra_hours_value);
      payload.triple_extra_hours_value = this.normalizeDecimalValue(payload.triple_extra_hours_value);
      payload.double_shifts_value = this.normalizeDecimalValue(payload.double_shifts_value);
      payload.triple_shifts_value = this.normalizeDecimalValue(payload.triple_shifts_value);
      payload.weekly_incentive_value = this.normalizeDecimalValue(payload.weekly_incentive_value);
      payload.fixed_complement = this.normalizeDecimalValue(payload.fixed_complement);
      payload.taxi_allowance = this.normalizeDecimalValue(payload.taxi_allowance);
      payload.attendance_group = this.normalizeTextValue(payload.attendance_group);
      payload.is_remote = payload.is_remote === true || payload.is_remote === "true";
      payload.regime_type = this.normalizeTextValue(payload.regime_type);
      payload.payment_method = this.normalizeTextValue(payload.payment_method);
      payload.payment_frequency = this.normalizeTextValue(payload.payment_frequency);
      payload.umf = this.normalizeTextValue(payload.umf);
      payload.bank1 = this.normalizeTextValue(payload.bank1);
      payload.bank1_account = this.normalizeTextValue(payload.bank1_account);
      payload.bank1_clabe = this.normalizeTextValue(payload.bank1_clabe);
      payload.bank2 = this.normalizeTextValue(payload.bank2);
      payload.bank2_account = this.normalizeTextValue(payload.bank2_account);
      payload.bank2_clabe = this.normalizeTextValue(payload.bank2_clabe);
      payload.bank_employee_number = this.normalizeIntegerValue(payload.bank_employee_number);
      payload.employee_status = this.normalizeStatusId(payload.employee_status);
      payload.employee_license_expiration = payload.employee_license_expiration || null;
      return payload;
    },
    async persistEmployeePayload(sourcePayload, successMessage) {
      const employee_ident = this.employeeDetails.employee_ident;
      const apiDirectory = process.env.API_DIRECTORY;
      this.saving_employee = true;
      const payload = this.buildEmployeePayload(sourcePayload);
      const response = await axios.put(`${apiDirectory}/employee_detail/${employee_ident}/`, payload);
      this.persistedEmployeeDetails = { ...response.data };
      this.localEmployeeDetails = { ...this.localEmployeeDetails, ...response.data };
      this.localEmployeeDetails.django_user_is_active_display = this.djangoUserActive;
      Swal.fire("Actualizado", successMessage, "success");
    },
    formatIncidentDateTime(value) {
      if (!value) return "-";
      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return String(value);
      return parsedDate.toLocaleString("es-MX");
    },
    incidentLevelLabel(value) {
      const option = this.incidentLevelOptions.find((item) => String(item.value) === String(value || ""));
      return option?.label || value || "-";
    },
    getLevelForIncidentType(typeValue) {
      const matched = EMPLOYEE_INCIDENT_CATALOG.find((row) => row.type === typeValue);
      return matched?.level || "";
    },
    getCategoryForIncidentType(typeValue) {
      const matched = EMPLOYEE_INCIDENT_CATALOG.find((row) => row.type === typeValue);
      return matched?.category || "";
    },
    filterIncidentTypesByCategory(categoryValue) {
      const normalizedCategory = String(categoryValue || "").trim();
      const rows = normalizedCategory
        ? EMPLOYEE_INCIDENT_CATALOG.filter((row) => row.category === normalizedCategory)
        : EMPLOYEE_INCIDENT_CATALOG;
      return [...new Set(rows.map((row) => row.type))];
    },
    hydrateFamilyMembers(source) {
      this.familyMembersList = this.normalizeFamilyMembers(source?.employee_family_members);
    },
    addFamilyMember() {
      this.familyMembersList.push(this.defaultFamilyMember());
    },
    removeFamilyMember(index) {
      this.familyMembersList.splice(index, 1);
      if (!this.familyMembersList.length) this.familyMembersList.push(this.defaultFamilyMember());
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    payrollFieldLabel(fieldName) {
      const labels = {
        employee_commission_percentage: "% Comisiones",
        agreed_salary: "Sueldo pactado",
        imss_base_salary: "Sueldo base IMSS",
        extra_hours_value: "Horas extras",
        triple_extra_hours_value: "Horas extras triples",
        double_shifts_value: "Turnos dobles",
        triple_shifts_value: "Turnos triples",
        weekly_incentive_value: "Premios semanales",
        fixed_complement: "Complemento fijo",
        taxi_allowance: "Pago de taxis",
      };
      return labels[fieldName] || fieldName;
    },
    formatHistoryValue(value) {
      if (value === null || value === undefined || value === "") return "Sin valor";
      return value;
    },
    formatHistoryDate(value) {
      if (!value) return "Sin fecha";
      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return String(value);
      return parsedDate.toLocaleString("es-MX");
    },
    buildPayrollHistoryHtml(rows) {
      if (!rows.length) {
        return "<p style='margin:0;'>No hay cambios registrados todavía.</p>";
      }
      const bodyRows = rows
        .map((row) => `
          <tr>
            <td>${this.escapeHtml(this.payrollFieldLabel(row.field_name))}</td>
            <td>${this.escapeHtml(this.formatHistoryValue(row.old_value))}</td>
            <td>${this.escapeHtml(this.formatHistoryValue(row.new_value))}</td>
            <td>${this.escapeHtml(row.username || "Sistema")}</td>
            <td>${this.escapeHtml(this.formatHistoryDate(row.changed_at))}</td>
          </tr>
        `)
        .join("");
      return `
        <div style="max-height: 420px; overflow:auto; text-align:left;">
          <table style="width:100%; border-collapse:collapse; font-size:12px;">
            <thead>
              <tr>
                <th style="text-align:left; border-bottom:1px solid #cbd5e1; padding:6px;">Campo</th>
                <th style="text-align:left; border-bottom:1px solid #cbd5e1; padding:6px;">Valor anterior</th>
                <th style="text-align:left; border-bottom:1px solid #cbd5e1; padding:6px;">Valor nuevo</th>
                <th style="text-align:left; border-bottom:1px solid #cbd5e1; padding:6px;">Usuario</th>
                <th style="text-align:left; border-bottom:1px solid #cbd5e1; padding:6px;">Fecha</th>
              </tr>
            </thead>
            <tbody>${bodyRows}</tbody>
          </table>
        </div>
      `;
    },
    async showPayrollHistory() {
      try {
        if (!this.employeeObjectId) return;
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/employee-payroll-history/${this.employeeObjectId}/`);
        const rows = Array.isArray(response.data) ? response.data : [];
        await Swal.fire({
          title: "Historial de nómina / sueldos",
          html: this.buildPayrollHistoryHtml(rows),
          width: 980,
          confirmButtonText: "Cerrar",
        });
      } catch (error) {
        console.error("Error fetching payroll history:", error);
        Swal.fire("Error", "No se pudo obtener el historial de cambios.", "error");
      }
    },
    async fetchCurrentUser() {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/current-user/`);
        const data = response.data || {};
        this.currentUserEmployeeId = data.employee_id || null;
        this.currentUserDisplay =
          data.employee_name ||
          data.employee_full_name ||
          data.full_name ||
          (data.first_name || data.last_name ? `${data.first_name || ""} ${data.last_name || ""}`.trim() : "") ||
          data.username ||
          "";
      } catch (error) {
        this.currentUserEmployeeId = null;
        this.currentUserDisplay = "";
      }
    },
    async fetchIncidentUnits() {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/employee-incident-unit-options/`);
        this.incidentUnits = Array.isArray(response.data?.results) ? response.data.results : [];
      } catch (error) {
        console.error("Error fetching incident units:", error);
        this.incidentUnits = [];
      }
    },
    async fetchEmployeeIncidents() {
      try {
        if (!this.employeeObjectId) return;
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/employee-incidents/${this.employeeObjectId}/`);
        this.employeeIncidents = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        if (error?.response?.status !== 404 && error?.response?.status !== 403) {
          console.error("Error fetching employee incidents:", error);
        }
        this.employeeIncidents = [];
      }
    },
    async createEmployeeIncident() {
      try {
        if (!this.canCreateIncident) {
          Swal.fire("Sin acceso", "No tienes permisos para crear incidencias.", "warning");
          return;
        }
        if (!this.employeeObjectId) return;
        const mappedLevel = this.getLevelForIncidentType(this.incidentDraft.type);
        if (!this.incidentDraft.occurrence_time || !this.incidentDraft.type || !this.incidentDraft.description) {
          Swal.fire("Campos obligatorios", "Completa fecha de ocurrencia, tipo y descripción.", "warning");
          return;
        }
        if (!mappedLevel) {
          Swal.fire("Tipo invalido", "El tipo seleccionado no tiene gravedad configurada.", "warning");
          return;
        }
        const payload = {
          occurrence_time: this.incidentDraft.occurrence_time,
          level: mappedLevel,
          type: this.incidentDraft.type,
          cost: this.normalizeDecimalValue(this.incidentDraft.cost),
          description: this.incidentDraft.description,
          unit: this.incidentDraft.unit || null,
          punishment_date: this.incidentDraft.punishment_date || null,
          punishment_description: this.normalizeTextValue(this.incidentDraft.punishment_description),
        };
        const apiDirectory = process.env.API_DIRECTORY;
        this.savingIncident = true;
        await axios.post(`${apiDirectory}/employee-incidents/${this.employeeObjectId}/`, payload);
        await this.fetchEmployeeIncidents();
        this.resetIncidentDraft();
        this.showIncidentForm = false;
        Swal.fire("Guardado", "La incidencia se registró correctamente.", "success");
      } catch (error) {
        console.error("Error creating employee incident:", error);
        Swal.fire("Error", "No se pudo registrar la incidencia.", "error");
      } finally {
        this.savingIncident = false;
      }
    },
    async deleteEmployeeIncident(incident) {
      try {
        if (!this.canDeleteIncident) {
          Swal.fire("Sin acceso", "No tienes permisos para eliminar incidencias.", "warning");
          return;
        }
        const result = await Swal.fire({
          title: "Eliminar incidencia",
          text: "Esta acción no se puede deshacer.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        });
        if (!result.isConfirmed) return;
        const apiDirectory = process.env.API_DIRECTORY;
        this.savingIncident = true;
        await axios.delete(`${apiDirectory}/employee-incident/${incident.id}/`);
        await this.fetchEmployeeIncidents();
        Swal.fire("Eliminado", "La incidencia fue eliminada.", "success");
      } catch (error) {
        console.error("Error deleting employee incident:", error);
        Swal.fire("Error", "No se pudo eliminar la incidencia.", "error");
      } finally {
        this.savingIncident = false;
      }
    },
    isIncidentClosed(incident) {
      return String(incident?.status || "").toLowerCase() === "cerrada";
    },
    incidentStatusClass(statusValue) {
      return this.isIncidentClosed({ status: statusValue }) ? "incident-status-pill--closed" : "incident-status-pill--review";
    },
    async closeEmployeeIncident(incident) {
      try {
        if (!this.canCloseIncident) {
          Swal.fire("Sin acceso", "No tienes permisos para cerrar incidencias.", "warning");
          return;
        }
        const result = await Swal.fire({
          title: "Cerrar incidencia",
          text: "La incidencia se marcará como Cerrada.",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Cerrar incidencia",
          cancelButtonText: "Cancelar",
        });
        if (!result.isConfirmed) return;
        const apiDirectory = process.env.API_DIRECTORY;
        this.savingIncident = true;
        await axios.post(`${apiDirectory}/employee-incident/${incident.id}/close/`);
        await this.fetchEmployeeIncidents();
        Swal.fire("Cerrada", "La incidencia se marcó como Cerrada.", "success");
      } catch (error) {
        console.error("Error closing employee incident:", error);
        Swal.fire("Error", "No se pudo cerrar la incidencia.", "error");
      } finally {
        this.savingIncident = false;
      }
    },
    incidentToDatetimeLocal(value) {
      if (!value) return "";
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return "";
      const pad = (num) => String(num).padStart(2, "0");
      return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
    },
    startEditIncident(incident) {
      if (!this.canEditIncident) {
        Swal.fire("Sin acceso", "No tienes permisos para editar incidencias.", "warning");
        return;
      }
      this.editIncidentDraft = {
        occurrence_time: this.incidentToDatetimeLocal(incident.occurrence_time),
        category: this.getCategoryForIncidentType(incident.type),
        level: this.getLevelForIncidentType(incident.type) || (incident.level ? String(incident.level) : ""),
        type: incident.type || "",
        cost: incident.cost ?? "",
        unit: incident.unit ?? null,
        punishment_date: incident.punishment_date || "",
        description: incident.description || "",
        punishment_description: incident.punishment_description || "",
      };
      this.editingIncidentId = incident.id;
    },
    cancelEditIncident() {
      this.editingIncidentId = null;
    },
    async saveIncidentEdits(incident) {
      try {
        if (!this.canEditIncident) {
          Swal.fire("Sin acceso", "No tienes permisos para editar incidencias.", "warning");
          return;
        }
        const mappedLevel = this.getLevelForIncidentType(this.editIncidentDraft.type);
        if (!this.editIncidentDraft.occurrence_time || !this.editIncidentDraft.type || !this.editIncidentDraft.description) {
          Swal.fire("Campos obligatorios", "Completa fecha de ocurrencia, tipo y descripción.", "warning");
          return;
        }
        if (!mappedLevel) {
          Swal.fire("Tipo invalido", "El tipo seleccionado no tiene gravedad configurada.", "warning");
          return;
        }
        const payload = {
          occurrence_time: this.editIncidentDraft.occurrence_time,
          level: mappedLevel,
          type: this.editIncidentDraft.type,
          cost: this.normalizeDecimalValue(this.editIncidentDraft.cost),
          unit: this.editIncidentDraft.unit || null,
          punishment_date: this.editIncidentDraft.punishment_date || null,
          description: this.editIncidentDraft.description,
          punishment_description: this.normalizeTextValue(this.editIncidentDraft.punishment_description),
        };
        const apiDirectory = process.env.API_DIRECTORY;
        this.savingIncidentEdits = true;
        await axios.put(`${apiDirectory}/employee-incident/${incident.id}/`, payload);
        await this.fetchEmployeeIncidents();
        this.editingIncidentId = null;
        Swal.fire("Guardado", "La incidencia se actualizó correctamente.", "success");
      } catch (error) {
        console.error("Error updating employee incident:", error);
        Swal.fire("Error", "No se pudo actualizar la incidencia.", "error");
      } finally {
        this.savingIncidentEdits = false;
      }
    },
    goBack() {
      history.back();
    },
    async deleteEmployee() {
      try {
        if (!this.canDelete) {
          Swal.fire("Sin acceso", "No tienes permisos para eliminar personal.", "warning");
          return;
        }
        const employee_ident = this.employeeDetails.employee_ident;
        const apiDirectory = process.env.API_DIRECTORY;
        await axios.delete(`${apiDirectory}/employee_detail/${employee_ident}/`);
        Swal.fire("Eliminado", "El empleado ha sido eliminado con éxito.", "success").then(() => {
          this.$router.push({ name: "RHPersonal" });
        });
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al eliminar el empleado.", "error");
      }
    },
    confirmDelete() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) this.deleteEmployee();
      });
    },
    async saveEmployeeProfile() {
      try {
        if (!this.canUpdate) {
          Swal.fire("Sin acceso", "No tienes permisos para actualizar personal.", "warning");
          return;
        }
        const payload = { ...this.localEmployeeDetails };
        const familyMembers = this.sanitizeFamilyMembers();
        if (familyMembers) {
          payload.employee_family_members = familyMembers;
        }
        await this.persistEmployeePayload(payload, "Los datos del empleado se actualizaron con éxito.");
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Hubo un problema al actualizar los datos del personal.", "error");
      } finally {
        this.saving_employee = false;
      }
    },
    async toggleDjangoUserStatus() {
      if (!this.localEmployeeDetails.django_user_username) {
        Swal.fire("Sin usuario", "Este empleado no tiene un usuario del sistema asignado.", "info");
        return;
      }
      try {
        if (!this.canUpdate) {
          Swal.fire("Sin acceso", "No tienes permisos para actualizar personal.", "warning");
          return;
        }
        const nextUserStatus = !this.djangoUserActive;
        this.localEmployeeDetails.django_user_is_active = nextUserStatus;
        const payload = {
          ...this.persistedEmployeeDetails,
          django_user_is_active: nextUserStatus,
        };
        await this.persistEmployeePayload(
          payload,
          `El usuario del sistema fue ${nextUserStatus ? "activado" : "desactivado"} correctamente.`,
        );
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "No se pudo actualizar el estatus del usuario del sistema.", "error");
      } finally {
        this.saving_employee = false;
      }
    },
    async toggleEmployeeStatus() {
      try {
        if (!this.canUpdate) {
          Swal.fire("Sin acceso", "No tienes permisos para actualizar personal.", "warning");
          return;
        }
        const nextStatus = this.employeeStatusIsInactive ? 1 : 2;
        this.localEmployeeDetails.employee_status = nextStatus;
        if (nextStatus === 2) {
          this.fillDeactivationDateWhenMissing();
        }
        const payload = {
          ...this.persistedEmployeeDetails,
          employee_status: nextStatus,
          employee_deactivation_date: this.localEmployeeDetails.employee_deactivation_date || null,
          employee_deactivation_reason: this.localEmployeeDetails.employee_deactivation_reason || null,
          employee_deactivation_notes: this.localEmployeeDetails.employee_deactivation_notes || null,
        };
        await this.persistEmployeePayload(
          payload,
          `El estatus interno del empleado se actualizó a ${nextStatus === 2 ? "Inactivo" : "Activo"}.`,
        );
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "No se pudo actualizar el estatus interno del empleado.", "error");
      } finally {
        this.saving_employee = false;
      }
    },
    async fetchEmployeeFiles() {
      try {
        if (!this.employeeObjectId) return;
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/get-files/`, {
          params: { object_type: "employee", object_id: this.employeeObjectId },
        });
        const files = Array.isArray(response.data) ? response.data : [];
        this.profilePhoto = null;
        this.imageFiles = [];
        this.documentFiles = [];

        files.forEach((file) => {
          const metadata = file.metadata || {};
          const mimeType = metadata.file_type || "";
          const category = metadata.category || (mimeType.startsWith("image/") ? "image" : "document");
          const item = {
            file_id: file.file_id,
            title: metadata.title || "",
            description: metadata.description || "",
            file_name: metadata.file_name || "",
            mime_type: mimeType,
            preview_url: `data:${mimeType || "application/octet-stream"};base64,${file.content}`,
          };

          if (category === "profile_photo") {
            this.profilePhoto = item;
          } else if (category === "image") {
            this.imageFiles.push(item);
          } else {
            this.documentFiles.push(item);
          }
        });
      } catch (error) {
        if (error?.response?.status !== 404) console.error("Error fetching employee files:", error);
        this.profilePhoto = null;
        this.imageFiles = [];
        this.documentFiles = [];
      }
    },
    async uploadProfilePhoto() {
      await this.uploadAnyEmployeeFile("profile_photo", true);
    },
    async uploadEmployeeFile(category) {
      await this.uploadAnyEmployeeFile(category, false);
    },
    async uploadAnyEmployeeFile(category, isProfilePhoto) {
      try {
        const file = await new Promise((resolve) => {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = isProfilePhoto || category === "image" ? "image/*" : "*/*";
          input.onchange = (event) => resolve(event.target.files?.[0] || null);
          input.click();
        });
        if (!file) return;

        const metadataPrompt = await Swal.fire({
          title: "Detalles del archivo",
          html: `
            <input id="employee-file-title" class="swal2-input" placeholder="Título" value="${(isProfilePhoto ? "Foto de perfil" : file.name).replace(/"/g, "&quot;")}">
            <textarea id="employee-file-description" class="swal2-textarea" placeholder="Descripción"></textarea>
          `,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Subir",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const title = document.getElementById("employee-file-title")?.value?.trim() || "";
            const description = document.getElementById("employee-file-description")?.value?.trim() || "";
            if (!title) {
              Swal.showValidationMessage("El título es obligatorio");
              return null;
            }
            return { title, description };
          },
        });
        if (!metadataPrompt.isConfirmed || !metadataPrompt.value) return;
        if (!this.employeeObjectId) return;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("object_type", "employee");
        formData.append("object_id", this.employeeObjectId);
        formData.append("object_metadata", JSON.stringify({
          category,
          title: metadataPrompt.value.title,
          description: metadataPrompt.value.description,
          file_name: file.name,
          file_type: file.type,
        }));

        const apiDirectory = process.env.API_DIRECTORY;
        this.uploadingMedia = true;
        await axios.post(`${apiDirectory}/upload-file`, formData);
        await this.fetchEmployeeFiles();
        Swal.fire("Completado", "Archivo subido correctamente.", "success");
      } catch (error) {
        console.error("Error uploading employee file:", error);
        Swal.fire("Error", "No se pudo subir el archivo.", "error");
      } finally {
        this.uploadingMedia = false;
      }
    },
    openFile(item) {
      if (!item?.preview_url) return;
      window.open(item.preview_url, "_blank");
    },
    downloadFile(item) {
      if (!item?.preview_url) return;
      const link = document.createElement("a");
      link.href = item.preview_url;
      link.download = item.file_name || item.title || `archivo-${item.file_id}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadAllEmployeeFiles() {
      const allFiles = [...this.imageFiles, ...this.documentFiles];
      if (!allFiles.length) {
        Swal.fire("Sin archivos", "No hay archivos para descargar.", "info");
        return;
      }
      allFiles.forEach((item, index) => {
        setTimeout(() => this.downloadFile(item), index * 160);
      });
      Swal.fire("Completado", "Se iniciaron las descargas de todos los archivos.", "success");
    },
    async deleteEmployeeFile(fileId) {
      try {
        const result = await Swal.fire({
          title: "Eliminar archivo",
          text: "¿Deseas eliminar este archivo?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
        });
        if (!result.isConfirmed) return;
        const apiDirectory = process.env.API_DIRECTORY;
        await axios.post(`${apiDirectory}/delete-file/`, { blob_id: fileId });
        await this.fetchEmployeeFiles();
        Swal.fire("Completado", "Archivo eliminado.", "success");
      } catch (error) {
        console.error("Error deleting employee file:", error);
        Swal.fire("Error", "No se pudo eliminar el archivo.", "error");
      }
    },
  },
};
</script>

<style scoped>
.employee-editor {
  min-height: 100vh;
  background: #e9edf5;
  color: #0f172a;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  background: #ffc434;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.16);
}

.logo-button {
  height: 46px;
  cursor: pointer;
}

.topbar-title {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.kicker {
  font-size: 12px;
  opacity: 0.75;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.topbar-title h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 900;
}

.subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  opacity: 0.8;
}

.topbar-actions {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

.tabs-wrap {
  max-width: 1280px;
  margin: 10px auto 76px;
  padding: 0 16px;
}

.tabs {
  display: flex;
  gap: 8px;
  overflow: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.tab {
  border: 1px solid #94a3b8;
  background: #f8fafc;
  border-radius: 10px;
  padding: 8px 10px;
  min-width: 170px;
  text-align: left;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.tab:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
}

.tab.active {
  border-color: #1d4ed8;
  background: #dbeafe;
  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.22);
}

.tab-label {
  display: block;
  font-weight: 900;
  font-size: 12px;
}

.tab-hint {
  display: block;
  font-size: 10px;
  opacity: 0.82;
  margin-top: 2px;
}

.tab-panel {
  margin-top: 10px;
}

.main-data-container {
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 10px;
}

.main-data-container.single-column {
  grid-template-columns: 1fr;
}

.maintenance-main {
  grid-column: span 10;
  display: grid;
  gap: 10px;
}

.maintenance-side {
  grid-column: span 4;
  display: grid;
  gap: 10px;
}

.main-data-container.single-column .maintenance-main,
.main-data-container.single-column .maintenance-side {
  grid-column: 1 / -1;
}

.container-card {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 0;
  border-top: none;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px solid #cbd5e1;
  background: #dbe3ef;
}

.maintenance-title-row {
  gap: 10px;
}

.section-title h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
}

.container-card-body {
  padding: 8px;
}

.pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #c7d2fe;
  color: #1e3a8a;
  font-weight: 900;
  font-size: 11px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.payroll-config-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.payroll-config-column {
  border: 1px solid #cbd5e1;
  padding: 10px;
  background: #fff;
  display: grid;
  gap: 8px;
  align-content: start;
  grid-auto-rows: max-content;
}

.payroll-config-column h5 {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 900;
  color: #1e293b;
}

.bank-layout {
  display: grid;
  gap: 6px;
}

.bank-row {
  display: grid;
  grid-template-columns: 170px 10px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
}

.bank-row--account {
  grid-template-columns: 170px 10px 110px minmax(0, 1fr);
}

.bank-label {
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.bank-label--multiline {
  line-height: 1.05;
}

.bank-sep {
  font-weight: 700;
  text-align: center;
}

.bank-input,
.bank-select {
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #94a3b8;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
}

.bank-input--wide {
  max-width: 100%;
}

.bank-input--short {
  max-width: 86px;
}

.bank-radio-group {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 28px;
}

.bank-radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
}

.bank-radio-group input[type="radio"] {
  width: 16px;
  height: 16px;
}

@media (max-width: 1400px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1120px) {
  .main-data-container {
    grid-template-columns: 1fr;
  }
  .maintenance-main,
  .maintenance-side {
    grid-column: 1 / -1;
  }
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .payroll-config-grid {
    grid-template-columns: 1fr;
  }
  .bank-row,
  .bank-row--account {
    grid-template-columns: 1fr;
  }
  .bank-label {
    text-align: left;
  }
  .bank-sep {
    display: none;
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 11px;
  font-weight: 900;
  color: #0f172a;
}

.field-control input,
.field-control select,
.field-control textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #94a3b8;
  background: #fff;
  outline: none;
  transition: box-shadow 120ms ease, border-color 120ms ease;
  font-size: 12px;
}

.field-control textarea {
  min-height: 76px;
  resize: vertical;
}

.radio-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 36px;
  width: 100%;
}

.radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
}

.radio-group input[type="radio"] {
  width: 16px;
  height: 16px;
}

.field-control input:focus,
.field-control select:focus,
.field-control textarea:focus {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.18);
}

.list-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  gap: 10px;
  align-items: end;
  padding: 8px 0;
  border-bottom: 1px solid #dbe3ef;
}

.list-row:last-child {
  border-bottom: none;
}

.mini-action-btn {
  padding: 4px 10px;
  font-size: 11px;
}

.btn {
  border: 1px solid #64748b;
  border-radius: 8px;
  padding: 8px 10px;
  font-weight: 900;
  font-size: 12px;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.10);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn.primary {
  background: #1d4ed8;
  color: #fff;
  border-color: #1e40af;
}

.btn.ghost {
  background: #e2e8f0;
}

.btn.danger {
  background: #ef4444;
  color: #fff;
  border-color: #dc2626;
}

.profile-photo-wrap {
  display: grid;
  gap: 10px;
  justify-items: center;
}

.profile-photo {
  width: 140px;
  height: 140px;
  border-radius: 999px;
  object-fit: cover;
  border: 3px solid #cbd5e1;
  background: #fff;
}

.status-grid {
  display: grid;
  gap: 10px;
}

.user-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-status-chip {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  border: 1px solid transparent;
}

.user-status-chip.active {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.user-status-chip.inactive {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.media-section {
  margin-bottom: 16px;
}

.media-header h5 {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 900;
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
}

.media-card {
  border: 1px solid #94a3b8;
  border-radius: 10px;
  background: #fff;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.media-add {
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #eff6ff;
  border-style: dashed;
  padding: 10px;
}

.media-plus {
  font-size: 42px;
  line-height: 1;
  font-weight: 900;
  color: #1d4ed8;
}

.media-add-label {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 800;
  color: #1e3a8a;
}

.media-preview {
  width: 100%;
  height: 120px;
  object-fit: cover;
  background: #e2e8f0;
}

.media-doc-icon {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #1e3a8a;
  font-size: 22px;
  font-weight: 900;
}

.media-meta {
  padding: 8px;
  display: grid;
  gap: 4px;
  flex: 1;
}

.media-meta h6 {
  margin: 0;
  font-size: 12px;
  font-weight: 900;
}

.media-meta p {
  margin: 0;
  font-size: 11px;
  color: #334155;
}

.media-actions {
  padding: 0 8px 8px;
  display: flex;
  gap: 6px;
}

.media-btn {
  flex: 1;
  padding: 6px 8px;
  font-size: 11px;
}

.remove-item-btn {
  background: #ef4444;
  color: #fff;
  border-color: #dc2626;
}

.list-row .remove-item-btn {
  padding: 6px 10px;
  font-size: 11px;
}

@media (max-width: 1400px) {
  .list-row {
    grid-template-columns: repeat(2, minmax(0, 1fr)) auto;
  }
}

@media (max-width: 900px) {
  .list-row {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
}

.media-download-all {
  padding: 6px 10px;
  font-size: 11px;
}

.incident-layout {
  display: grid;
  gap: 10px;
}

.incident-card {
  border: 1px solid #cbd5e1;
  background: #fff;
  padding: 10px;
  display: grid;
  gap: 8px;
}

.incident-card-new {
  border-color: #93c5fd;
  background: #eff6ff;
}

.incident-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.incident-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.incident-form-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.incident-card-header h5 {
  margin: 0;
  font-size: 13px;
  font-weight: 900;
}

.incident-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.incident-status-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  border: 1px solid transparent;
  white-space: nowrap;
}

.incident-status-pill--review {
  background: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.incident-status-pill--closed {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.incident-signature-view {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  padding: 8px;
  display: flex;
  justify-content: center;
}

.incident-signature-view img {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
}

.incident-signature-empty {
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 14px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  background: #f8fafc;
}

.incident-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.field-full {
  grid-column: 1 / -1;
}

.incident-empty {
  padding: 10px;
  border: 1px dashed #94a3b8;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

@media (max-width: 900px) {
  .incident-grid {
    grid-template-columns: 1fr;
  }
}

.savebar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 25;
  background: rgba(226, 232, 240, 0.96);
  backdrop-filter: blur(10px);
  border-top: 1px solid #94a3b8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
}

.savebar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.savebar-text {
  font-size: 12px;
  opacity: 0.9;
  font-weight: 700;
}

.savebar-actions {
  display: flex;
  gap: 10px;
}
</style>